import { LayoutContext } from 'contexts/LayoutContext';
import { useContext } from 'react';
import { AccountManagementStackRoutes, AccountManagementStackScreenProps } from '../../account.navigator';
import { TransactionInfoNativeScreen } from './TransactionInfoNative.screen';
import { TransactionInfoWebScreen } from './TransactionInfoWeb.screen';

export const TransactionInfoScreen: React.FC<AccountManagementStackScreenProps<AccountManagementStackRoutes.Xmetadata>> = ({ route }) => {
  const { xmetadata } = route.params;
  const layout = useContext(LayoutContext);

  if (layout.isMobile) {
    return <TransactionInfoNativeScreen xmetadata={xmetadata} />;
  }
  return <TransactionInfoWebScreen xmetadata={xmetadata} />;
};
